import { makeObservable, observable } from 'mobx';
import React from 'react';
import { Route } from 'react-router-dom';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';
function invariant(cond: any, message: any) {
    if (!cond) throw new Error(message);
}


export function createRoutesFromChildren(children: React.ReactNode): BreadcrumbsRoute[] {
    let routes: BreadcrumbsRoute[] = [];
    React.Children.forEach(children, element => {
        if (!React.isValidElement(element)) {
            return;
        }

        if (element.type === React.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children));
            return;
        }

        !(element.type === Route) ? process.env['NODE_ENV'] !== "production" ? invariant(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : invariant(false, undefined) : void 0;
        let route: BreadcrumbsRoute = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            breadcrumb: element.props.breadcrumb,
        };
        //this is the magic that makes useRouteBreadCrumb work, by making breadcrumb observable, we can update it from anywhere in the app and trigger observers to re-render it.
        makeObservable(route, {
            "breadcrumb": observable
        });

        if (element.props.children) {
            route.children = createRoutesFromChildren(element.props.children);
        }

        routes.push(route);
    });
    return routes;
}
